import PropTypes from 'prop-types'
import {useEffect} from 'react'

import MixpanelLogger from '../../../../../lib/MixpanelLogger'

const CheckEmail = props => {
  useEffect(() => {
    MixpanelLogger.track('view_email_sent')
  }, [])

  return (
    <div className='info-container'>
      <div className='container-content'>
        <h1>Please check your email to confirm your account</h1>
        <div className='email-info'>
          <p>We've sent an email to <strong>{props.email}</strong>.</p>
          <p>If you don’t receive the email, please check the spam folder and double check the email address.</p>
          <p>The subject line of the email is "Confirmation instructions."</p>
          <a onClick={props.resendConfirmationEmail}>Resend confirmation email</a>
        </div>
      </div>
    </div>
  )
}

CheckEmail.defaultProps = {
  email: ''
}

CheckEmail.propTypes = {
  email: PropTypes.string,
  resendConfirmationEmail: PropTypes.func
}

export default CheckEmail
